import React from 'react';
import Navbar from '../components/LandingPageNew/Navbar';
import Hero from '../components/Career/Hero';
import CareerBenefits from '../components/Career/CareerBenefits';
import SalesManager from '../components/Career/SalesManager';
import Faq from '../components/LandingPageNew/Faq';
import Footer from '../components/LandingPageNew/Footer';
import SEO from '../components/Shared/SEO';
const Career = () => {
   const tabs = [
    { id: "general", label: "Allgemein" },
    { id: "process", label: "Prozess" },
    { id: "support", label: "Support" },
  ];
  const faqData = {
    general: [
      {
        question: "Ist ein Quereinstieg möglich?",
        answer:
          "Egal, aus welchem Bereich du kommst – wenn du Begeisterung, Lernbereitschaft und eine positive Einstellung mitbringst, bist du bei uns genau richtig. Dein frischer Blick und deine einzigartige Perspektive können einen bedeutenden Beitrag zu unserem Team und unseren Projekten leisten.",
      },
      {
        question: "Wie bewerbe ich mich?",
        answer:
          "Ein Lebenslauf und kurzes Motivationsschreiben an karriere@uneva.de genügen. Gerne kannst Du uns auch vorab anrufen.",
      },
      {
        question: "Worauf kommt es in einem Gespräch mit euch an?",
        answer: `Wir schätzen Individualität & Transparenz. Bei uns musst Du dich nicht verstellen. Wir möchten Dich kennenlernen und Dir einen Überblick für die angestrebte Stelle verschaffen.`,
      },
      {
        question: "Wie läuft der Bewerbungsprozess ab?",
        answer:
          "Nach Erhalt deiner Unterlagen laden wir Dich zu einem kurzen Kennenlern Gespräch (ca. 15-20 Minuten) via Telefon ein. Bei beidseitigem Interesse folgt im Office ein persönliches Kennenlernen und finales Gespräch. ",
      }
     
    ],
    
  };

  return (

    <>
    <SEO
                title="Karriere bei uns | UNEVA "
                description="Gestalte mit uns die digitale Zukunft. Entdecke spannende 
Karrieremöglichkeiten in einem modernen Team mit Raum für Ideen und Entwicklung."
                canonical="https://uneva.de/karriere"
              />
               <div className="relative min-h-screen">
      {/* Navbar on top of hero */}
      <Navbar />
      <Hero />
      <CareerBenefits />
      <SalesManager/>
      <Faq title={
          <>
           Hilfreiche Fragen & Antworten 
          </>
        }
        subtitle="Deine Frage ist nicht dabei? Gerne kannst du uns eine E-Mail hinterlassen und wir melden uns schnellstmöglich zurück."
        tabs={tabs}
        faqData={faqData}
        defaultTab="general" />
        <Footer/>
    </div>
    </>
   
  );
};

export default Career;
